import * as React from 'react';

import { isNullOrWhitespace } from '@/utils/stringHelper';
import i18n, { getDateFormatOptions } from '@/utils/i18n';
import { EditItem } from '../Layout';
import { Table } from 'reactstrap';
import { ContentSection } from '../Layout/ContentSection';

/**
 * Only to be used in EditMerchantOrder
 */
export const DpdStatusHistory = function dpdStatusHistory(props: {
  dpdStatusCodesJson: string | null;
}) {
  if (isNullOrWhitespace(props.dpdStatusCodesJson)) {
    return (
      <ContentSection title="DPD Status" locked>
        <div></div>
      </ContentSection>
    );
  }
  const dpdStatusCodes = JSON.parse(props.dpdStatusCodesJson as string);

  function getFormattedDateString(dateString: string) {
    if (isNullOrWhitespace(dateString)) {
      return '-';
    }
    const date = new Date(dateString);
    return date.toLocaleDateString(i18n.language, getDateFormatOptions(true));
  }
  const rows = Object.entries(dpdStatusCodes).map(
    ([trackingNumber, data]: [string, any]) => (
      <tr key={trackingNumber}>
        <td>{trackingNumber}</td>
        <td>{getFormattedDateString(data.DATA_TRANSMITTED)}</td>
        <td>{getFormattedDateString(data.ON_THE_ROAD)}</td>
        <td>{getFormattedDateString(data.AT_DELIVERY_DEPOT)}</td>
        <td>{getFormattedDateString(data.OUT_FOR_DELIVERY)}</td>
        <td>{getFormattedDateString(data.DELIVERED)}</td>
      </tr>
    ),
  );

  return (
    <ContentSection title="DPD Status" locked>
      <Table striped hover>
        <thead>
          <tr>
            <th>DPD Tracking</th>
            <th>Data Transmitted</th>
            <th>On the Road</th>
            <th>At Delivery Depot</th>
            <th>Out for Delivery</th>
            <th>Delivered</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </Table>
    </ContentSection>
  );
};
